import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const getLogin = createAsyncThunk(
  "Auth/getLogin",
  async (resD, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/login`,
          {
            ...resD,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getLogout = createAsyncThunk(
  "Auth/getLogout",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/logout`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRoles = createAsyncThunk(
  "Admin/getRoles",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/roles`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            guard_name: "restaurant",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getPermissions = createAsyncThunk(
  "Admin/getPermissions",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/admin/permissions`, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: {
            guard_name: "restaurant",
          },
        })
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getAdminDetails = createAsyncThunk(
  "Admin/getAdminDetails",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/admins/me/profile`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getAdmin = createAsyncThunk(
  "Admin/getAdmin",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/admins`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
          params: data && data,
        }
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const addAdmin = createAsyncThunk(
  "Admin/addAdmin",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/admins`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const EditAdmin = createAsyncThunk(
  "Admin/EditAdmin",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/admins/${data.id}/update`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);

      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const delAdmin = createAsyncThunk(
  "Admin/delAdmin",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_API}api/restaurant/admins/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            lang: Cookies.get("zado_lng"),
            Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getAdminId = createAsyncThunk(
  "Admin/getAdminId",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const data = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/restaurant/admins/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              lang: Cookies.get("zado_lng"),
              Authorization: `Bearer ${Cookies.get("zado_restaurant_Token")}`,
            },
          }
        )
        .then((res) => res.data);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
const AuthSlice = createSlice({
  name: "Auth",
  initialState: {
    isAuthLoading: false,
    error: null,
    LoginArr: null,
    RolesArr: null,
    PermissionsArr: null,
    AdminDetailsArr: null,
    AdminIDArray: null,
    getAdminArray: null,
  },

  extraReducers: {
    [getLogin.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [getLogin.fulfilled]: (state, action) => {
      state.LoginArr = action.payload.data;
      state.isAuthLoading = false;
    },
    [getLogin.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    // getLogout
    [getLogout.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [getLogout.fulfilled]: (state, action) => {
      state.LoginArr = action.payload.data;
      state.isAuthLoading = false;
    },
    [getLogout.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    // getRoles
    [getRoles.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [getRoles.fulfilled]: (state, action) => {
      state.RolesArr = action.payload.data;
      state.isAuthLoading = false;
    },
    [getRoles.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    // getPermissions
    [getPermissions.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [getPermissions.fulfilled]: (state, action) => {
      state.PermissionsArr = action.payload.data;
      state.isAuthLoading = false;
    },
    [getPermissions.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    //
    [getAdminDetails.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [getAdminDetails.fulfilled]: (state, action) => {
      state.AdminDetailsArr = action.payload.data;
      state.isAuthLoading = false;
    },
    [getAdminDetails.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    [addAdmin.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [addAdmin.fulfilled]: (state, action) => {
      state.isAuthLoading = false;
    },
    [addAdmin.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    //
    //
    [delAdmin.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [delAdmin.fulfilled]: (state, action) => {
      state.isAuthLoading = false;
    },
    [delAdmin.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    //
    //
    [EditAdmin.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [EditAdmin.fulfilled]: (state, action) => {
      state.isAuthLoading = false;
    },
    [EditAdmin.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    //
    [getAdminId.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [getAdminId.fulfilled]: (state, action) => {
      state.AdminIDArray = action.payload.data;
      state.isAuthLoading = false;
    },
    [getAdminId.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
    //
    [getAdmin.pending]: (state, action) => {
      state.isAuthLoading = true;
    },
    [getAdmin.fulfilled]: (state, action) => {
      state.getAdminArray = action.payload.data;
      state.isAuthLoading = false;
    },
    [getAdmin.rejected]: (state, action) => {
      state.isAuthLoading = false;
    },
  },
});

export default AuthSlice.reducer;
